const purchaseProcess = [
  {
    group: 'General',
    columns: [
      {
        name: 'id',
        id: 'info-id',
        show: false
      },
      {
        name: 'Numero Pedido',
        id: 'info-pedido',
        show: true
      },
      {
        name: 'Tipo Pedido ',
        id: 'info-tipo',
        show: true
      },
      {
        name: 'Data Criação ',
        id: 'info-cria',
        show: true
      },
      {
        name: 'Horário Criação',
        id: 'info-cria-hora',
        show: true
      },
      {
        name: 'Data Finalização',
        id: 'info-finalizacao',
        show: true
      },
      {
        name: 'Centro de Envio',
        id: 'centro-envio',
        show: true
      },
      {
        name: 'Data Remessa ',
        id: 'info-rem',
        show: true
      },

      {
        name: 'Código Produto',
        id: 'produto-id',
        show: true
      },
      {
        name: 'Nome Produto',
        id: 'produto-nome',
        show: true
      },
      {
        name: 'Código Fornecedor',
        id: 'fornecedor-id',
        show: true
      },
      {
        name: 'Nome Fornecedor',
        id: 'fornecedor-nome',
        show: true
      },

      {
        name: 'Quantidade ',
        id: 'info-quant',
        show: true
      },
      {
        name: 'Peso Bruto ',
        id: 'info-peso',
        show: true
      },
      {
        name: 'Mensagem',
        id: 'info-mensgaem',
        show: true
      },
      {
        name: 'Tipo Processo ',
        id: 'info-proce',
        show: false
      },

      {
        name: 'Usuario ',
        id: 'info-user',
        show: true
      }

      // {
      //   name: 'Status',
      //   id: 'info-status',
      //   show: true
      // }
    ]
  }
]

export default purchaseProcess
